import { api } from 'components/api'
import { surveyResponsePath } from 'components/routes/api'
import {
  toSurveyResponseData,
  toApiSurveyAnswer,
  type ApiSurveyAnswer,
  type ApiSurveyResponseResponse,
  type SurveyAnswer,
  type SurveyResponseData
} from 'components/surveys/responses/services/surveyResponseData'

interface UpdateSurveyResponseParams {
  responseId: number
  answers: SurveyAnswer[]
}

export const updateSurveyResponse = async ({
  responseId,
  answers
}: UpdateSurveyResponseParams): Promise<SurveyResponseData> => {
  const response = await api.putWithCsrf<{ answers: ApiSurveyAnswer[] }, ApiSurveyResponseResponse>({
    url: surveyResponsePath(responseId),
    headers: { Accept: 'application/json' },
    data: { answers: answers.map(toApiSurveyAnswer) }
  })

  return toSurveyResponseData(response.data)
}
